export const settlementData = [

    ////////////////////////
    //  -={Settlement}=- {0-6}
    ////////////////////////

    {"title": "d50 Settlement name (part 1)...", "id":"d50settlementnamepart1", "roll":[
        "Stone",
        "Water",
        "Leaf",
        "Ice",
        "Flame",
        "Sol",
        "Storm",
        "Earth",
        "Gleam",
        "Star",
        "Art",
        "War",
        "Heart",
        "Hard",
        "Fall",
        "Rock",
        "Doom",
        "Oak",
        "Tear",
        "Raven",
        "Badger",
        "Snake",
        "Lion",
        "Hell",
        "Rage",
        "Brine",
        "Rat",
        "Buck",
        "Lily",
        "Core",
        "Stench",
        "Mage",
        "God",
        "Soil",
        "Pure",
        "Mal",
        "Cam",
        "Fen",
        "Clear",
        "Split",
        "Founder's ",
        "Heir",
        "Fair",
        "Spin",
        "Lord's ",
        "King's ",
        "Servant's ",
        "Demon's ",
        "Snow",
        "Land's ",   
        "Ash",
        "Ald",
        "Bright",
        "Brim",
        "Bel",
        "Crown",
        "Buck",
        "Bram",
        "Dagger",
        "Down",
        "Col",
        "Dark",
        "Ever",
        "Dorn",
        "Deep",
        "Grim",
        "Fel",
        "Flame",
        "Hard",
        "Harren",
        "Frost",
        "Horn",
        "Inns",
        "Gold",
        "Lake",
        "Kar",
        "Hammer",
        "Never",
        "Mal",
        "Helms",
        "River",
        "Mur",
        "Moon",
        "Rock",
        "Os",
        "Nether",
        "Rose",
        "Ril",
        "Rune",
        "Salt",
        "Roth",
        "Silver",
        "Sand",
        "Shep",
        "Spell",
        "Sharp",
        "Stan",
        "Summer",
        "Stark",
        "Torr",
        "Star",
        "Tar",
        "Whis",
        "Storm",
        "Wick",
        "Wicken",
        "Sun",
        "Wind",
        "Yeo",
        "Winter"]},
    {"title": "d50 Settlement name (part 2)...", "id":"d50settlementnamepart2", "roll":[
        "crest",
        "bridge",
        "run",
        "catch",
        "blade",
        "haven",
        "rise",
        "more",
        "light",
        "main",
        "blaze",
        "place",
        "tear",
        "fold",
        "rest",
        "host",
        "craft",
        "lair",
        "hollow",
        "vale",
        "hammer",
        "pike",
        "rail",
        "spike",
        "ring",
        "henge",
        "coil",
        "spring",
        "jaw",
        "mark",
        "hail",
        "loch",
        "child",
        "keep",
        "fort",
        "brook",
        "forth",
        "melt",
        "borourgh",
        "ford",
        "crawl",
        "moral",
        "combe",
        "glen",
        "garden",
        "wish",
        "fellow",
        "ridge",
        "ward",
        "town",
        "bridge",
        "burgh",
        "beacon",
        "brook",
        "burton",
        "breaker",
        "cliff",
        "by",
        "burn",
        "cross",
        "cham",
        "claw",
        "fall",
        "chester",
        "dale",
        "fast",
        "combe",
        "fell",
        "fields",
        "dall",
        "finger",
        "ford",
        "don",
        "garden",
        "gate",
        "enden",
        "grove",
        "hall",
        "est",
        "guard",
        "head",
        "hal",
        "haven",
        "hold",
        "lant",
        "isle",
        "law",
        "lington",
        "market",
        "mark",
        "lund",
        "pass",
        "point",
        "more",
        "reach",
        "ridge",
        "sall",
        "shield",
        "stock",
        "shaw",
        "song",
        "well",
        "ton",
        "tower",
        "wick",
        "wold",
        "vale",
        "wood",
        "wyn",
        "watch"   ]},
    {"title": "d6 Population size...", "id":"d6populationsize", "roll":[
        "50 people (hamlet)",
        "100 people (small village)",
        "250 people (village)",
        "1,000 people (small town)",
        "5,000 people (town)",
        "25,000 people (city)",   ]},
    {"title": "d100 Main inhabitants are...", "id":"d100maininhabitantsare", "roll":[
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Humans",
        "Wood Elves",
        "Wood Elves",
        "Wood Elves",
        "Wood Elves",
        "Wood Elves",
        "High Elves",
        "High Elves",
        "High Elves",
        "High Elves",
        "High Elves",
        "High Elves",
        "High Elves",
        "High Elves",
        "High Elves",
        "Eladrin",
        "Eladrin",
        "Half-Elves",
        "Half-Elves",
        "Drow",
        "Drow",
        "Mountain Dwarves",
        "Mountain Dwarves",
        "Mountain Dwarves",
        "Mountain Dwarves",
        "Mountain Dwarves",
        "Mountain Dwarves",
        "Mountain Dwarves",
        "Mountain Dwarves",
        "Mountain Dwarves",
        "Mountain Dwarves",
        "Hill Dwarves",
        "Hill Dwarves",
        "Hill Dwarves",
        "Hill Dwarves",
        "Hill Dwarves",
        "Lightfoot Halflings",
        "Lightfoot Halflings",
        "Lightfoot Halflings",
        "Stout Halflings",
        "Stout Halflings",
        "Rock Gnomes",
        "Rock Gnomes",
        "Forest Gnomes",
        "Forest Gnomes",
        "Deep Gnomes",
        "Dragonborn",
        "Dragonborn",
        "Dragonborn",
        "Dragonborn",
        "Dragonborn",
        "Orcs and Half-Orcs",
        "Orcs and Half-Orcs",
        "Orcs and Half-Orcs",
        "Tieflings and Fiends",
        "Tieflings and Fiends",
        "Aarakocra",
        "Aarakocra",
        "Genasi and Elementals",
        "Genasi and Elementals",
        "Shifters and Lycanthropes",
        "Shifters and Lycanthropes",
        "Goliaths and Giants",
        "Changelings and Doppelgangers",
        "Warforged and Construcst",
        "Aasimar and Celestials",   ]},
    {"title": "d20 The settlement's atmosphere is...", "id":"d20thesettlementsatmosphereis", "roll":[
        "Calm",
        "Quaint",
        "Peaceful",
        "Vaguely unsettling",
        "Decidedly sinister",
        "Tense",
        "Violent",
        "Fearful",
        "Bustling",
        "Tumultuous",
        "Chaotic",
        "Pleasant",
        "Dark",
        "Heavy",
        "Stifling",
        "Relaxing",
        "Freeing",
        "Spiritual",
        "Apathetic",
        "Grief-stricken",   ]},
    {"title": "d100 A prominent feature of the settlement is...", "id":"d100aprominentfeatureofthesettlementis", "roll":[
        "Its beautiful parks.",
        "Its majestic orchards.",
        "A notable library.",
        "A powerful guild.",
        "The smell of baked bread.",
        "The sounds of blacksmiths working.",
        "The abundance of game in the surrounding land.",
        "The extensive farmland surrounding it.",
        "Its exotic goods.",
        "The slums.",
        "Its criminal syndicate.",
        "Its high-class brothels.",
        "Its ban on prostitution.",
        "That it is protected by thick stone walls.",
        "That it stands atop a floating mote of earth.",
        "Its visible magic wards, which repel monsters.",
        "That it is constantly besieged.",
        "That it is ruled by a tyrant.",
        "The law is enforced harshly.",
        "The lack of government; anarchy reigns.",
        "A large temple.",
        "A gated cemetery larger than is warranted.",
        "A system of tunnels beneath the settlement.",
        "A planar gate.",
        "A powerful curse.",
        "That adventurers are hated by the people.",
        "A mysterious obelisk towers over other buildings.",
        "A famous entertainer inhabits the settlement.",
        "That magic is hated by the people.",
        "Its heavily armed, well-trained guards.",
        "The tamed monster that defends it.",
        "A well-traveled trade route that runs through it.",
        "Its \"friendly\" barmaids.",
        "The local ale distillery.",
        "A keep of a noble lord.",
        "A tower in which a princess is locked up.",
        "That it's overrun with pests.",
        "That it's in an economic depression.",
        "That it's being extorted by an intelligent monster.",
        "A group of refugees tenting near the settlement.",
        "That it's on the path of a gypsy caravan.",
        "That a traveling carnival often passes through.",
        "The nearby vineyards.",
        "Its history as a battleground.",
        "Its proximity to a monster stronghold.",
        "A wishing well with a local legend.",
        "That it is built in a dead magic zone.",
        "That it is built in a wild magic zone.",
        "That it was the site of a mythic event.",
        "That it was built atop ancient ruins.",
        "A statue honoring some long-dead hero.",
        "An abundance of a particular animal.",
        "A shrine to an evil god.",
        "An affordable periodical carrying news of the realm.",
        "A peaceful cult.",
        "Its wide streets.",
        "Its incredibly beautiful architecture.",
        "Its patronage of the arts.",
        "The nearby academy of magic.",
        "The rare herbs that grow nearby.",
        "The use of glowing crystal as streetlamps.",
        "The settlement's astronomy observatory.",
        "A bridge that spans a wide river.",
        "The fiercely patriotic inhabitants.",
        "A gallows erected in the main square.",
        "A genial ghost.",
        "Its \"no-weapons\" policy.",
        "A corrupt politician.",
        "Regular raids by a nearby group of bandits.",
        "That it was founded by cannibals, and some continue the tradition.",
        "That it's actually a bandit base.",
        "That all light except sunlight is smothered.",
        "That it was the location of a pirate's unclaimed treasure hoard.",
        "The nearby mines.",
        "A history of assassinations.",
        "Its very progressive attitude.",
        "Its staunch conservative attitude.",
        "Its incompetent buffoon of a leader.",
        "Its paranoia.",
        "Its xenophobia.",
        "Its tolerance of others.",
        "A coven of witches as rulers.",
        "Its predominantly male population.",
        "Its predominantly female population.",
        "Its high concentration of children.",
        "Its noticeable lack of children.",
        "Its connection to the Feywild.",
        "Its connection to the Shadowfell.",
        "Its grimy feel.",
        "The stench of sewage.",
        "A river that divides it.",
        "The undead servants that perform labor.",
        "That it's the center of a manhunt.",
        "A pony mascot with an adorable name.",
        "The overpowering smell of sulfur.",
        "A low hum that permeates the settlement with no known cause.",
        "A thousand-year-old tree in town square.",
        "That it is under the protection of friendly elemental spirits.",
        "The blistering heat of its forges.",
        "Its famous impartiality.",   ]},
    {"title": "d30 The players should care about the settlement because...", "id":"d30theplayersshouldcareaboutthesettlementbecause", "roll":[
        "It has magic item shop(s).",
        "A dungeon was discovered nearby recently.",
        "A powerful wizard lives there.",
        "A NPC the players have met before is there.",
        "Something they want is there.",
        "A thief stole something from them here.",
        "It was mentioned in a letter found on a slain foe.",
        "They are hired by someone in the settlement.",
        "This is the only settlement with which to resupply within leagues.",
        "One of the inhabitants asked for help with a problem.",
        "It is the only save haven from the monster-infested surroundings.",
        "They are implicated in a crime and asked not to leave town.",
        "There are some interesting rumors about their foes.",
        "The players liberated some prisoners who asked to be taken there.",
        "An enemy has called them out.",
        "The rewards on the job board are high.",
        "Things don't quite add up; perhaps investigation is called for.",
        "It keeps getting mentioned wherever they go.",
        "The townspeople greet them like heroes.",
        "They need to take shelter from a severe storm.",
        "They need help that the settlement can provide.",
        "A child/helpless NPC is in danger and needs help.",
        "There are signs of a monster infestation.",
        "A creature whose goals clash with theirs lives there.",
        "A powerful NPC tries to put them under a \"geas\".",
        "A patron promises them jobs there.",
        "They hear rumors of a hidden magic item nearby.",
        "A strange crime is committed, peripherally involving them.",
        "A local NPC did them a favor, and wants to cash in.",
        "A powerful entity offers them a deal there.",   ]},
       
    ////////////////////////
    //  -={Nation}=- {7-21}
    ////////////////////////

    {"title": "d6 Age The nation is...", "id":"d6agethenationis_nation", "roll":[
        "Ancient; No one remembers when it was founded",
        "Very Old; It has been standing for millennia",
        "Old; It has been around for centuries",
        "Young; The elderly can remember when it was formed",
        "Very Young; It was founded within the past generation",
        "Fledgling: It was very recently founded",   ]},
    {"title": "d10 Political System The nation is run by...", "id":"d10politicalsystemthenationisrunby_nation", "roll":[
        "Democracy; Every citizen has an equal say in how the government is run",
        "Republic; Individuals represent groups of citizens",
        "Monarchy; A ruling class passes leadership through a predisposed line of sovereignty",
        "Empire; A wide-spread collection of states or communities with complex organization to maintain fealty to the ruler",
        "Dictatorship; A single all-powerful ruler lords over the people",
        "Tribal; There is no specific ruler, rather there is an uncoordinated group of tribes",
        "Anarchy; There is no centralized government nor authority. The people are self-policing",
        "Communism; The ruling class distributes all aspects of society including economics, jobs, resources, and where to live to make sure everyone has an equal share.",
        "Theocracy; Religious leaders hold the power, and laws are dictated by religious beliefs",
        "Oligarchy; A small group of people maintain control of the nation",   ]},
    {"title": "d20 Economics The dominant economic influence is...", "id":"d20economicsthedominanteconomicinfluenceis_nation", "roll":[
        "Manorial agriculture. Serfs and freemen work their lord's land.",
        "Trade guilds. Conglomerates of tradespeople control the means of producing and distributing the most valuable goods.",
        "Nomadic grazing. Herds of domestic animals roam freely, and people follow their movements.",
        "Feudalism. The rulers control all land, and designate landholders to oversee production, distribution and taxation in those areas.",
        "Cottage industry. Small, family groups produce most trade goods.",
        "Mercantilism. Trade is strictly regulated by the government, in favor of local production.",
        "Corporatism. Different areas of the economy are controlled by defined organizations, often given national charter.",
        "Family conglomeratism. A few key families control production and distribution across multiple industries.",
        "Syndicalism. Groups of workers control production and distribution in different areas of the economy.",
        "Communism. The state controls the means of production, and distributes goods evenly to the population.",
        "Hunting and gathering. Food is obtained by foraging.",
        "Post-scarcity. Most goods needed for survival are available cheaply/freely to all.",
        "Market system. Goods are produced and traded freely by individuals and groups.",
        "Industrialism. Mining and manufacturing dominate the economy.",
        "Knowledge economy. Scribes, theologians and other knowledge workers dominate be economy.",
        "Mages. Magic-users control the means of production and distribution.",
        "The church or churches. The means of production and distribution are controlled by religious leaders.",
        "Manorial agriculture and roll again on this table.",
        "Trade. There is no centralized currency. Citizens trade for all goods and services",
        "Benevolent Deity. A powerful being or group of powerful beings gives the people what it sees fit.",   ]},
    {"title": "d12 Ruler The ruler(s) of the nation is...", "id":"d12rulertherulersofthenationis_nation", "roll":[
        "A demagogue; He rules the nation through fear and prejudices",
        "A philosopher",
        "A military leader",
        "A council of elders",
        "A council of randomly selected citizens",
        "Corporations",
        "A power hungry dictator",
        "A manipulative politician",
        "A noble philanthropist",
        "A religious zealot",
        "A puppet of a secret society",
        "A figure-head. The real power lies at the local level",   ]},
    {"title": "d30 A unique characteristic of the nation is...", "id":"d30auniquecharacteristicofthenationis_nation", "roll":[
        "Prisoners are offered a chance at freedom if they can win a gladiatorial game. The games are... (d6): 1. Rigged. Prisoners are not intended to survive; 2. Extremely difficult, almost no one ever survives; 3. Fair. A skilled warrior has a chance at winning; 4. Easy. Just about anyone with a bit of skill can win; 5. Unbalanced; Many enter, only one leaves; 6. Massive. Hundreds enter at a time, but only a few survive",
        "It is undergoing a civil war",
        "It is experiencing extreme inflation",
        "It is at war with another nation",
        "It is controlled by a secret society pulling the strings",
        "The political system is collapsing",
        "It is believe to be protected by a god",
        "The citizens believe it to be the greatest nation in the world",
        "It is the home of a legendary warrior",
        "It is the home of a famous philosopher",
        "It is undefeated in battle",
        "It is imperialistic; always trying to conquer new territory",
        "It is isolationist; it does not like interacting with other nations",
        "It is the home of a legendary artifact",
        "It is extremely strict with its laws",
        "Vigilantism is condoned",
        "It is a pillar of moral values",
        "It is generally hated by other nations",
        "Its borders are open to refugees",
        "It is being crippled by sanctions from other nations",
        "It has been invaded by another nation",
        "A popular and respected public figure recently died",
        "Slavery is an accepted practice",
        "Women are considered to be lesser people",
        "Men are considered to be lesser people",
        "The people observe a single day each year when all crime is legal",
        "All trials are settled through death by combat",
        "All trials are settled through a sporting competition",
        "Annual gladiatorial combat is held, and the participants are randomly selected among the citizens",
        "A citizen is randomly selected, and sacrificed annually",   ]},
    {"title": "d8 Founding The nation was founded by...", "id":"d8foundingthenationwasfoundedby_nation", "roll":[
        "Revolutionaries seeking freedom from an oppressive government",
        "A power-hungry tyrant",
        "A religious order",
        "A philosopher wanting to experiment with a new social order",
        "A tribe that evolved into a nation",
        "An explorer who claimed the land for his own",
        "A god",
        "A cult claiming a bastion separate from society",   ]},
    {"title": "Sub-divisions To manage the nation, it is split into multiple...", "id":"sub-divisionstomanagethenationitissplitintomultiple_nation", "roll":[
        "Autonomous states",
        "Fiefdoms",
        "Cities",
        "Duchies",
        "Provinces",
        "Geographical regions",   ]},
    {"title": "d12 Mood The citizens are...", "id":"d12moodthecitizensare_nation", "roll":[
        "Miserable; They hate their government or leaders, and feel oppressed",
        "Unhappy; They don't like the state of their nation, and don't feel like they are valued or treated well",
        "Satiated; Though they may not like things about the government, they are happy enough with their current life to risk losing what they have",
        "Happy; Even if things aren't perfect, they are generally happy with their way of life",
        "Extremely happy; They love their lives",
        "Angry; They are being pushed to their limits",
        "Patriotic; They love their nation, and will die to protect it",
        "Confused; They people feel like the nation is in a state of turmoil, and don't know what tomorrow will hold",
        "Anxious; Something bad is coming, they just know it, even if they don't know what it is",
        "Frightened; People gather for safety, or stay in their homes at night",
        "Scared; People live in fear of their nation's leaders",
        "Indifferent; The politics of the nation are unimportant in day to day life",   ]},
    {"title": "d5 Wealth and Prosperity The citizens are...", "id":"d5wealthandprosperitythecitizensare_nation", "roll":[
        "Very well off; They enjoy the finer things in life",
        "Doing well; Their needs are met, and they have the ability to improve their station in life",
        "They have enough to get by, but not enough to improve their station in life",
        "Poor; The people are barely scraping by",
        "Desperate; They are lucky to find food and shelter",   ]},
    {"title": "d10 Religion The nation's approach to religion is...", "id":"d10religionthenationsapproachtoreligionis_nation", "roll":[
        "A specific religion is required of all citizens.",
        "A specific religion is encouraged, but not required. All other religions are banned",
        "The nation allows a select list of acceptable religions",
        "The nation allows any religion, but bans a select list",
        "All religions are welcome, though some are discouraged",
        "All religions are welcome, though some are encouraged",
        "Religion is banned all together",
        "A single religion is very popular, while others are generally considered to be strange or blasphemous",
        "Two or more religions are warring to be the only nationally sponsored religion",
        "Religion is not important to the people, nor the rulers.",   ]},
    {"title": "d50 Laws A notable law includes...", "id":"d50lawsanotablelawincludes_nation", "roll":[
        "Hunting of a specific species is banned (d100): 1. Wolves; 2. Lions; 3. Tigers; 4. Chickens; 5. Bears; 6. Elf; 7. Boar; 8. Apes; 9. Monkeys; 10. Axe Beaks; 11. Baboons; 12. Badgers; 13. Blink Dogs; 14. Leopards; 15. Hawks; 16. Eagles; 17. Crocodiles; 18. Alligators; 19. Death Dogs; 20. Dire Wolves; 21. Horses; 22. Deer; 23. Moose; 24. Elephants; 25. Giant Apes; 26. Giant Badgers; 27. Giant Bats; 28. Giant Boar; 29. Giant Centipede; 30. Giant Snakes; 31. Giant Crab; 32. Giant Crocodile; 33. Giant Alligator; 34. Giant Elk; 35. Giant Fire Beetles; 36. Giant Frogs; 37. Goats; 38. Giant Goats; 39. Giant Lizards; 40. Octopuses; 41. Giant Octopuses; 42. Giant Owls; 43. Owls; 44. Giant Rats; 45. Rats; 46. Giant Scorpions; 47. Sharks; 48. Giant Sharks; 49. Giant Spiders; 50. Giant Toads; 51. Giant Vultures; 52. Giant Wasps; 53. Giant Weasels; 54. Weasels; 55. Whales; 56. Hyenas; 57. Jackals; 58. Killer Whales; 59. Mammoths; 60. Dogs; 61. Panthers; 62. Ravens; 63. Rhinoceros; 64. Saber-Toothed Tigers; 65. Worgs; 66. Giraffes; 67. Ankhegs; 68. Cockatrice; 69. Bulettes; 70. Basilisks; 71. Chimera; 72. Dinosaurs; 73. Displacer Beasts; 74. Undead; 75. Gnolls; 76. Goblins; 77. Griffons; 78. Harpies; 79. Hippogriffs; 80. Kobolds; 81. Lizardfolk; 82. Manticore; 83. Ogres; 84. Orcs; 85. Owlbears; 86. Pixies; 87. Sprites; 88. Trolls; 89. Unicorns; 90. Yetis; 91. Demons; 92. Dragons; 93. Giants; 94. Lycanthropes; 95. Cougars; 96. Cats; 97. Turtles; 98. Dolphins; 99. Brownies; 100. Kangaroos",
        "Capital punishment for most crimes",
        "Magic is banned",
        "Drug use is legal",
        "Alcohol use is banned",
        "Citizens are not allowed to speak poorly of their leaders",
        "Military service is required of all citizens",
        "Religious leaders must register with a local authority",
        "Revenge killing is legal",
        "Magic users must register with a local authority",
        "Begging is illegal",
        "Prostitution is illegal",
        "The native population is a protected class",
        "The native population can be hunted for a reward",
        "The native population can be hunted for sport",
        "No one is allowed to own more than an acre of land",
        "Everyone is guaranteed an acre of land",
        "The nation maintains protected land that may be not be used by private citizens",
        "No animal may be ridden",
        "No citizen is allowed to use a pack animal",
        "No citizen is allowed to use animals to assist with farming, or heavy labor",
        "Soldiers are not allowed to enter a citizen's home without permission",
        "A citizen's private property is not allowed to be searched with out permission",
        "Prima Nocta; Leaders have first rights to deflower newly-weds",
        "Animal fighting is banned",
        "It is illegal to impersonate a member of the clergy",
        "It is illegal to bite off another person's leg",
        "It is illegal to walk backwards after sunset",
        "Fishing is prohibited",
        "Divorce is illegal",
        "It is only legal to move large groups of animals at certain times of the day",
        "Profanities may not be spoken in public",
        "It is legal to hunt and kill members of a specific religion",
        "Escape from prison is not illegal",
        "Public affection is illegal",
        "It is illegal to feed animals in public places",
        "All persons in public must be bathed, and perfumed",
        "All food sold must be approved by a local authority",
        "All weapons must be registered with a local authority",
        "All procreation is regulated, and must be approved by the government",
        "All deforestation must be approved by a local authority",
        "All farms must be approved by a local authority",
        "All citizens are required to do regular charity work",
        "Martial weapons are prohibited",
        "Citizens may kill trespassers",
        "Bounty hunting is illegal",
        "Money changing is illegal",
        "Money lending is illegal",
        "Gambling is illegal",
        "Businesses are not allowed to operate an a specific day each week",   ]},
    {"title": "d20 Language The common spoken language is...", "id":"d20languagethecommonspokenlanguageis_nation", "roll":[
        "Common and one other language (roll again on this table)",
        "Two languages (roll two more times on this table)",
        "Common",
        "Dwarvish",
        "Elvish",
        "Draconic",
        "Abyssal",
        "Celestial",
        "Deep Speech",
        "Druidic",
        "Giant",
        "Gnomish",
        "Goblin",
        "Gnoll",
        "Halfling",
        "Infernal",
        "Orc",
        "Primordial",
        "Sylvan",
        "Undercommon",   ]},
    {"title": "d8 Xenophobia The various races are treated...", "id":"d8xenophobiathevariousracesaretreated_nation", "roll":[
        "The races get along, but a single race is hated by all others (d10): 1. Dwarves; 2. Elves; 3. Tieflings; 4. Humans; 5. Halflings; 6. Gnomes; 7. Gnomes; 8. Hybrid races (half-orcs, half-elves); 9. Dragonborn; 10. An additional race is hated. (roll twice on this table)",
        "The races do not get along, but a single race is revered by all others (d10): 1. Dwarves; 2. Elves; 3. Tieflings; 4. Humans; 5. Halflings; 6. Gnomes; 7. Gnomes; 8. Hybrid races (half-orcs, half-elves); 9. Dragonborn; 10. An additional race is revered. (roll twice on this table)",
        "Each race hates all other races",
        "Each race lives in peace with all other races, but stick to their own",
        "Humans and Demi-humans (dwarves, elves, etc) get along, but do not tolerate sub-humans (goblinoids, orcs, etc)",
        "Each race tolerates the others, but they don't get along well",
        "The races are split into factions. Each faction hates the others",
        "The races mix freely",   ]},
    {"title": "d10 Class System Social classes in the society are determined by...", "id":"d10classsystemsocialclassesinthesocietyaredeterminedby_nation", "roll":[
        "Age",
        "Race",
        "Profession",
        "Lineage",
        "Birthplace",
        "Height",
        "Wealth",
        "Gender",
        "Eye color",
        "Hair color",
        "Skin color",
        "Religion",   ]},
    {"title": "d20 Social Pariahs Social outcasts generally include...", "id":"d20socialpariahssocialoutcastsgenerallyinclude_nation", "roll":[
        "Bastards",
        "Lycanthropes",
        "The ill",
        "The elderly",
        "The homeless",
        "Mercenaries",
        "Druids",
        "Rangers",
        "Law breakers",
        "Merchants",
        "Magic users",
        "The clergy",
        "Local law enforcement",
        "Widows and Widowers",
        "Oath-breakers",
        "The Dishonored",
        "Followers of a specific religion",
        "Drunks",
        "Prostitutes",
        "Foreigners",   ]},
            
    ////////////////////////////
    //  -={Continent}=- {22-31}
    ////////////////////////////

    {"title": "d6 Size The continent is...", "id":"d6sizethecontinentis_continent", "roll":[
        "Massive; It spans most of the world",
        "Large; It makes an impact on the shape of the world",
        "Medium; About as average as average gets",
        "Small; It may be hard to find with out exploration",
        "Tiny; It's practically an island",
        "Amalgamated; A collection of landmasses into a single continent. Roll twice on this table, larger of the two rolls is the area the continent covers, Smaller is the size of the land masses in the area.",   ]},
    {"title": "d8 Location The continent is located...", "id":"d8locationthecontinentislocated_continent", "roll":[
        "Polar; It sits one of of the polar ends of the world",
        "Equatorial; It straddles the world's equator",
        "Far North; The sun never sets half the year, and never rises the other half",
        "Far South; The sun never sets half the year, and never rises the other half",
        "Northern Hemisphere",
        "Southern Hemisphere",
        "Runs laterally across both hemispheres",
        "Hidden; It can not be easily found",   ]},
    {"title": "d10 Sub-Climates Compared to the rest of the the world, the continent is...", "id":"d10sub-climatescomparedtotherestofthetheworldthecontinentis_continent", "roll":[
        "Warmer than usual",
        "Colder than usual",
        "Windier than usual",
        "Rainier than usual",
        "Rather average",
        "More tropical than usual",
        "Incredibly Hot",
        "Incredibly Cold",
        "Incredibly wet",
        "More humid than usual",   ]},
    {"title": "d20 A unique characteristic of this continent is...", "id":"d20auniquecharacteristicofthiscontinentis_continent", "roll":[
        "It is the only place to find a rare mineral (d10): 1. Gold; 2. Silver; 3. Copper; 4. Adamantine; 5. Titanium; 6. Tungsten; 7. Platinum; 8. Electrum; 9. Uranium; 10. Unobtanium",
        "It was recently ravaged by a major cataclysm (d6): 1. A massive meteor changed the entire landscape; 2. A massive volcano erupted, blacking out the sky; 3. A drought caused massive dust storms, and food became scarce; 4. Massive floods wiped out anyone that was not prepared; 5. A god became angry and punished the people by scorching the land; 6. A pandemic spread like wildfire, killing 60 percent of the population",
        "It is dominated by a single land type (d10): 1. Mountains; 2. Desert; 3. Forests; 4. Jungle; 5. Tundra; 6. Plains; 7. Lakes; 8. Rivers; 9. Swamp / Marshland; 10. Canyons",
        "It is home to an ancient volcano that has been erupting for generations",
        "It is said to be protected by a god",
        "It is home to the tallest mountain in the world",
        "It is home to the largest lake in the world",
        "An unnaturally massive number of chickens roam the wild",
        "Most of it is below sea level",
        "It is pock marked with craters",
        "A powerful enchantment has befallen it",
        "It has been afflicted by a powerful curse",
        "It is landlocked",
        "It has no neighbouring continents",
        "Massive storms make the coast uninhabitable",
        "At the center is a font of wild magic",
        "It is said to hide a legendary artifact",
        "It was claimed by a legendary hero",
        "It was claimed by a legendary villain",
        "It used to be joined with another continent, but was split asunder.",   ]},
    {"title": "d6 Discovery When was the continent was discovered", "id":"d6discoverywhenwasthecontinentwasdiscovered_continent", "roll":[
        "Long before memory or written history",
        "Centuries ago",
        "A few generations ago",
        "A generation ago",
        "Very recently",
        "It has not yet been discovered",   ]},
    {"title": "d12 Discovery The continent was discovered by...", "id":"d12discoverythecontinentwasdiscoveredby_continent", "roll":[
        "A travelling merchant looking for new riches",
        "A nomadic tribe wandering aimlessly",
        "A small group of pilgrims looking for greener pastures",
        "Refugees from a massive war",
        "Colonists sent by the ruler of another land seeking to expand his borders",
        "Explorers looking for something new and exciting",
        "Map makers looking for fill in gaps of a map",
        "A small civilization escaping from a stronger, more dominant monster",
        "A small civilization seeking better a better climate",
        "Frontiersman pushing the edges of the know world.",
        "No one, it was the cradle of civilization",
        "Priests seeking worshippers",   ]},
    {"title": "d100 Domestic Creatures Creatures unique to this continent include... (Roll 2d4 times)", "id":"d100domesticcreaturescreaturesuniquetothiscontinentincluderoll2d4times_continent", "roll":[
        "Monkeys",
        "Apes",
        "Baboons",
        "Pelicans",
        "Deer",
        "Cows",
        "Elk",
        "Bison",
        "Coyotes",
        "Dingos",
        "Wolves",
        "Swans",
        "Lions",
        "Tigers",
        "Brown Bears",
        "Grizzly Bears",
        "Polar Bears",
        "Tarantulas",
        "Blink Dogs",
        "Badgers",
        "Wolverines",
        "Black Bears",
        "Giraffes",
        "Llamas",
        "Alpacas",
        "Chickens",
        "Hawks",
        "Eagles",
        "Tortoises",
        "Boars",
        "Cougars",
        "Mere Cats",
        "Camels",
        "Panthers",
        "Boa Constrictors",
        "Crocodiles",
        "Alligators",
        "Horses",
        "Pandas",
        "Koalas",
        "Kangaroos",
        "Wallabies",
        "Death Dogs",
        "Axe Beaks",
        "Elephants",
        "Flying Snakes",
        "Scorpions",
        "Hyenas",
        "Vultures",
        "Goats",
        "Jackals",
        "Mammoths",
        "Phase Spiders",
        "Rhinoceroses",
        "Saber-Toothed tigers",
        "Worgs",
        "Dire Wolves",
        "Giant Badgers",
        "Giant Rats",
        "Giant Spiders",
        "Dire Chickens",
        "Giant Eagles",
        "Giant Boars",
        "Giant Centipedes",
        "Giant Bats",
        "Giant Snakes",
        "Giant Crabs",
        "Giant Crocodiles",
        "Giant Elk",
        "Giant Fire Beetles",
        "Giant Frogs",
        "Giant Goats",
        "Giant Hyenas",
        "Giant Lizards",
        "Iguanas",
        "Giant Owls",
        "Giant Scorpions",
        "Giant Toads",
        "Giant Vultures",
        "Giant Wasps",
        "Giant Weasels",
        "Weasels",
        "Giant Wolf Spiders",
        "Owlbears",
        "Sloths",
        "Dodo Birds",
        "Basilisks",
        "Cockatrice",
        "Griffons",
        "Hippogriffs",
        "Squirrels",
        "Chipmunks",
        "Buffalo",
        "Ostriches",
        "Zebras",
        "Geese",
        "Mongooses",
        "Lemurs",
        "Pigs",
        "Platypi",   ]},
    {"title": "d100 Foreign Creatures Creatures imported to this continent include... (Roll 1d4 times)", "id":"d100foreigncreaturescreaturesimportedtothiscontinentincluderoll1d4times_continent", "roll":[
        "Monkeys",
        "Apes",
        "Baboons",
        "Pelicans",
        "Deer",
        "Cows",
        "Elk",
        "Bison",
        "Coyotes",
        "Dingos",
        "Wolves",
        "Swans",
        "Lions",
        "Tigers",
        "Brown Bears",
        "Grizzly Bears",
        "Polar Bears",
        "Tarantulas",
        "Blink Dogs",
        "Badgers",
        "Wolverines",
        "Black Bears",
        "Giraffes",
        "Llamas",
        "Alpacas",
        "Chickens",
        "Hawks",
        "Eagles",
        "Tortoises",
        "Boars",
        "Cougars",
        "Mere Cats",
        "Camels",
        "Panthers",
        "Boa Constrictors",
        "Crocodiles",
        "Alligators",
        "Horses",
        "Pandas",
        "Koalas",
        "Kangaroos",
        "Wallabies",
        "Death Dogs",
        "Axe Beaks",
        "Elephants",
        "Flying Snakes",
        "Scorpions",
        "Hyenas",
        "Vultures",
        "Goats",
        "Jackals",
        "Mammoths",
        "Phase Spiders",
        "Rhinoceroses",
        "Saber-Toothed tigers",
        "Worgs",
        "Dire Wolves",
        "Giant Badgers",
        "Giant Rats",
        "Giant Spiders",
        "Dire Chickens",
        "Giant Eagles",
        "Giant Boars",
        "Giant Centipedes",
        "Giant Bats",
        "Giant Snakes",
        "Giant Crabs",
        "Giant Crocodiles",
        "Giant Elk",
        "Giant Fire Beetles",
        "Giant Frogs",
        "Giant Goats",
        "Giant Hyenas",
        "Giant Lizards",
        "Iguanas",
        "Giant Owls",
        "Giant Scorpions",
        "Giant Toads",
        "Giant Vultures",
        "Giant Wasps",
        "Giant Weasels",
        "Weasels",
        "Giant Wolf Spiders",
        "Owlbears",
        "Sloths",
        "Dodo Birds",
        "Basilisks",
        "Cockatrice",
        "Griffons",
        "Hippogriffs",
        "Squirrels",
        "Chipmunks",
        "Buffalo",
        "Ostriches",
        "Zebras",
        "Geese",
        "Mongooses",
        "Lemurs",
        "Pigs",
        "Platypi",   ]},
    {"title": "d100 Domestic Plants Plants unique to this continent include... (Roll 2d4 Times)", "id":"d100domesticplantsplantsuniquetothiscontinentincluderoll2d4times_continent", "roll":[
        "Roses",
        "Ferns",
        "Pine Trees",
        "Maple Trees",
        "Birch Trees",
        "Black Ash Trees",
        "White Ash Trees",
        "Aspens",
        "Willows",
        "Butternut Trees",
        "Black Cherry Trees",
        "Chestnut Trees",
        "Cottonwood Trees",
        "Elms",
        "Firs",
        "Hemlock",
        "Hickory",
        "Oak Trees",
        "Spruce Trees",
        "Sycamores",
        "Walnut Trees",
        "Peach Trees",
        "Orange Trees",
        "Plum Trees",
        "Apple Trees",
        "Baobab Trees",
        "Olive Trees",
        "Cedars",
        "Banyan Trees",
        "Yews",
        "Mulberry Trees",
        "Lavender",
        "Beech Trees",
        "Poplars",
        "Pear Trees",
        "Redwoods",
        "Junipers",
        "Strawberries",
        "Blueberries",
        "Blackberries",
        "Raspberries",
        "Potatoes",
        "Carrots",
        "Poppies",
        "Azaleas",
        "Begonias",
        "Bloodroot",
        "Carnations",
        "Chrysanthemum",
        "Tumbleweed",
        "Geranium",
        "Hyacinth",
        "Iris",
        "Celery",
        "Lavender",
        "Morning Glory",
        "Bell Pepper",
        "Mint",
        "Cumin",
        "Oregano",
        "Garlic",
        "Orchid",
        "Sunflower",
        "Tulip",
        "Poison Ivy",
        "Poison Oak",
        "Onions",
        "Spinach",
        "Watermelon",
        "Mustard",
        "Apricot Trees",
        "Banana Trees",
        "Pineapple",
        "Mangos",
        "Palm Trees",
        "Dragonfruit Trees",
        "Avocados",
        "Fig Trees",
        "Grapes",
        "Guava",
        "Kiwifruit",
        "Lemon Trees",
        "Line Trees",
        "Papaya Trees",
        "Pomegranate Trees",
        "Tomatoes",
        "Rice",
        "Brussel Sprouts",
        "Cabbage",
        "Pumpkin",
        "Radishes",
        "Turnips",
        "Corn",
        "Wheat",
        "Bok Choy",
        "Arugula",
        "Ivy",
        "Chickweed",
        "Dandelion",
        "Dill",   ]},
    {"title": "d100 Foreign Plants Plants imported to this continent include... (Roll 1d4 Times)", "id":"d100foreignplantsplantsimportedtothiscontinentincluderoll1d4times_continent", "roll":[
        "Roses",
        "Ferns",
        "Pine Trees",
        "Maple Trees",
        "Birch Trees",
        "Black Ash Trees",
        "White Ash Trees",
        "Aspens",
        "Willows",
        "Butternut Trees",
        "Black Cherry Trees",
        "Chestnut Trees",
        "Cottonwood Trees",
        "Elms",
        "Firs",
        "Hemlock",
        "Hickory",
        "Oak Trees",
        "Spruce Trees",
        "Sycamores",
        "Walnut Trees",
        "Peach Trees",
        "Orange Trees",
        "Plum Trees",
        "Apple Trees",
        "Baobab Trees",
        "Olive Trees",
        "Cedars",
        "Banyan Trees",
        "Yews",
        "Mulberry Trees",
        "Lavender",
        "Beech Trees",
        "Poplars",
        "Pear Trees",
        "Redwoods",
        "Junipers",
        "Strawberries",
        "Blueberries",
        "Blackberries",
        "Raspberries",
        "Potatoes",
        "Carrots",
        "Poppies",
        "Azaleas",
        "Begonias",
        "Bloodroot",
        "Carnations",
        "Chrysanthemum",
        "Tumbleweed",
        "Geranium",
        "Hyacinth",
        "Iris",
        "Celery",
        "Lavender",
        "Morning Glory",
        "Bell Pepper",
        "Mint",
        "Cumin",
        "Oregano",
        "Garlic",
        "Orchid",
        "Sunflower",
        "Tulip",
        "Poison Ivy",
        "Poison Oak",
        "Onions",
        "Spinach",
        "Watermelon",
        "Mustard",
        "Apricot Trees",
        "Banana Trees",
        "Pineapple",
        "Mangos",
        "Palm Trees",
        "Dragonfruit Trees",
        "Avocados",
        "Fig Trees",
        "Grapes",
        "Guava",
        "Kiwifruit",
        "Lemon Trees",
        "Line Trees",
        "Papaya Trees",
        "Pomegranate Trees",
        "Tomatoes",
        "Rice",
        "Brussel Sprouts",
        "Cabbage",
        "Pumpkin",
        "Radishes",
        "Turnips",
        "Corn",
        "Wheat",
        "Bok Choy",
        "Arugula",
        "Ivy",
        "Chickweed",
        "Dandelion",
        "Dill",   ]},
            
    ////////////////////////
    //  -={World}=- {32-41}
    ////////////////////////

    {"title": "d8 Size The world is...", "id":"d8sizetheworldis_world", "roll":[
        "Absolutely Massive. Generations could explore the world, and never see everything",
        "Giant. There are many world maps, showing different parts of the world, but none are complete",
        "Huge. With concerted effort over many generations, a world map can be created, with many gaps",
        "Large. The world is known, but no one man can see it all in a lifetime",
        "Medium. While most people don't know then extent of the world, scholars have been able to build some good maps",
        "Small. Most people have heard of most parts of the world, even if they have never travelled there",
        "Tiny. World-wide commerce is not unheard of",
        "Minuscule. The common person could get from one side of the world to the other.",   ]},
    {"title": "d12 Climate The world is...", "id":"d12climatetheworldis_world", "roll":[
        "Diverse. There exists a little bit of any type of climate somewhere in the world",
        "Ice-age. The world is mostly covered in tundra",
        "Hot. A cold spot above-ground is difficult to find",
        "Dry. The world is devoid of rain",
        "Verdant. The world is lush, and mostly uninhabited.",
        "A post-apocalyptic wasteland. The world is pock marked with uninhabitable regions",
        "Bi-polar. A single day/night cycle can go from extremely hot, to extremely cold",
        "Volcanic. Mountains and volcanoes are not uncommon, spewing gasses into the atmosphere",
        "Lush. It rains frequently. Jungles cover must of the world, and other regions are a vibrant green",
        "Stormy. The world is mostly under a cloud cover, with violent winds, rains, thunder and lightning.",
        "Windy. High-velocity winds scour the land",
        "Mild. There exists a comfortable amount of sun, rain and cloud-cover.",   ]},
    {"title": "d10 Land Masses The world is composed of...", "id":"d10landmassestheworldiscomposedof_world", "roll":[
        "Mostly ocean, with the occasional small island",
        "A single continent, amidst a massive ocean containing the occasional island",
        "Several distinct continents",
        "A single land mass, an no ocean to speak of",
        "Many small to medium sized islands speckled throughout the ocean",
        "Two distinct continents",
        "A ring of land, with an ocean in the center",
        "Many continents, some joined to others",
        "Two to three large continents, and a few smaller continents",
        "No land. The entire world is one giant ocean",   ]},
    {"title": "d8 Magic in the world is...", "id":"d8magicintheworldis_world", "roll":[
        "Non-existent",
        "Extremely rare. Though there are a few practitioners of magic, it is mostly in the realm of rumour or legend.",
        "Rare. There is usually only one or two people in a region that practice the magical arts",
        "Uncommon. Magic is real, but magical feats are considered impressive.",
        "Common. It's not unusual to see magic in use",
        "Extremely common. Magic is a part of daily life.",
        "Powering everything. Magic is so inundated in every contraption, it seems futuristic",
        "Wild. Results are never predictable, and strange things occur naturally",   ]},
    {"title": "d6 Technology in the world is...", "id":"d6technologyintheworldis_world", "roll":[
        "Primitive. A pulley system is considered complex",
        "Technology comes from relics of an age past. No one really understands how it works",
        "Basic. There is no electricity nor steam.",
        "Steam-powered. Steam powered contraptions can be found",
        "Slightly advanced. Gunpowder can be found, as well as steam power contraptions",
        "Advanced. Electricity has been discovered",   ]},
    {"title": "d20 A unique characteristic of this world is...", "id":"d20auniquecharacteristicofthisworldis_world", "roll":[
        "The sun is a different color (d8): 1. Red; 2. Blue; 3. Green; 4. White; 5. Black; 6. Violet; 7. Purple: 8. Prismatic",
        "There is an over-abundance of a mineral (d20): 1. Gold; 2. Silver; 3. Copper; 4. Lead; 5. Granite; 6. Adamantine; 7. Titanium; 8. Iron; 9. Aluminium; 10. Tin; 11. Salt; 12. Sulfur; 13. Cobalt; 14. Nickle; 15. Zinc; 16. Tungsten; 17. Platinum; 18. Electrum; 19. Mercury; 20. Uranium",
        "There is an scarcity of a mineral (d20): 1. Gold; 2. Silver; 3. Copper; 4. Lead; 5. Granite; 6. Adamantine; 7. Titanium; 8. Iron; 9. Aluminium; 10. Tin; 11. Salt; 12. Sulfur; 13. Cobalt; 14. Nickle; 15. Zinc; 16. Tungsten; 17. Platinum; 18. Electrum; 19. Mercury; 20. Uranium",
        "There are multiple moons",
        "There are multiple suns",
        "The sun rarely sets",
        "The world is in the midts of an apocalypse. (See below)",
        "The world is hollow. Entire civilizations can be found inside the world",
        "Most people live underground",
        "The air is toxic",
        "The gods have disappeared",
        "The pantheon of gods have been replaced by a single all-powerful god",
        "A pandemic ravages the world",
        "A civilization lives on the moon",
        "The gods walk among the men",
        "There is no sun. The world is shrouded in darkness.",
        "Seasons last for a very long time",
        "Rain is toxic",
        "No child has been born in a generation",
        "No one lives after attaining adulthood",   ]},
    {"title": "d8 The wold is dominated by...", "id":"d8thewoldisdominatedby_world", "roll":[
        "A single race or people.",
        "A pair of rival races or people.",
        "A large world-spanning empire.",
        "A pair of large, rival empires.",
        "A patchwork of many nations all vying for power.",
        "Warring, militaristic or barbaric clans.",
        "No one in particular",
        "An other-worldly power",   ]},
    {"title": "d8 Races Naturally occurring races include", "id":"d8racesnaturallyoccurringracesinclude_world", "roll":[
        "Only humans",
        "Only a single type of demi-human (dwarf, elf, etc)",
        "Humans and demi-humans",
        "Humans, demi-humans, and extra-planar beings",
        "Only humans, and a single type of demi-humans",
        "Demi-humans are common, but humans are rare",
        "Sub-humans, such as goblins, and orcs",
        "Evolved, intelligent monsters along side humans and demi-humans",   ]},
    {"title": "d20 A cataclysm that faced this world in the past was...", "id":"d20acataclysmthatfacedthisworldinthepastwas_world", "roll":[
        "A new species was born or discovered that tried to take over the world. (d12): 1. Dragons; 2. Mind-flayers; 3. Dark elves; 4. A vampire; 5. A lich; 6. A fiend; 7; A celestial; 8. A beholder; 9. Dinosaurs; 10. Dopplegangers; 11. Mimics; 12. Titans",
        "The material plane crossed with another plane causing the planes to bleed into each other (d20) 1. The Astral Plane; 2. The Ethereal Plane; 3. The Feywild; 4. Shadowfell; 5. The Elemental Plane of Air; 6. The Elemental Plane of Earth; 7. The Elemental Plane of Water; 8. The Elemental Plane of Fire; 9. Pandemonium; 10. The Abyss; 11. The Blessed Fields of Elysium; 12. The Wilderness of The Beastlands; 13. The Olympian Glades of Arborea; 14. The Heroic Domains of Ysgard; 15. The Ever-Changing Chaos of Limbo; 16. The Tarterian Depths of Carceri; 17. The Gray Waste of Hades; 18. The Bleak Eternity of Gehenna; 19. The Nine Hells of Baator; 20. The Infinite Battlefield of Acheron",
        "Meteors that ravaged the land",
        "An ice-age, of which only the strong could survive",
        "A world-wide flood that only the smart could survive",
        "A world-wide dust storm that lasted for a generation",
        "An advanced civilization that destroyed their own planet, leaving only what you see",
        "Famine wracked the land for many generations",
        "A war between gods spilled out into the material plane, and nearly destroyed it",
        "A war between dragons decimated any semblance of society",
        "Invasions from an extra-planar species",
        "The birth of magic.",
        "Magic became wild and unpredictable",
        "Overpopulation. There just weren't enough resources to support all of the people living in the world, and 99% of them died of hunger",
        "A man made super-weapon that destroyed the world",
        "The core of the world became unstable, and it was being torn asunder.",
        "The living never stayed dead, and the undead nearly overran everything",
        "A fool wizard performed a wish spell that tore at the very fabric of existence",
        "The magnetic polar fields switched",
        "The world was split down the middle, now two worlds orbit each other in close proximity.",   ]},
    {"title": "d20 The word was created by (Individual legends may vary)...", "id":"d20thewordwascreatedbyindividuallegendsmayvary_world", "roll":[
        "It was created as one of many experiments by a council of gods trying to discover... (d8) 1. The soul; 2. True sentience and free-will; 3. A purpose for their eternity; 4. A new form of magic; 5. A superior species that would some day replace them; 6. A superior species that would some day serve them; 7. A superior species that would be pit against another council's species in a game of war; 8. A new non-naturally occurring material, such as plastic.",
        "Billions of years of evolution",
        "A single creator god",
        "A momentary merge of the elemental planes",
        "As a peace offering between two warring gods",
        "As an offering of love from one god in love with another",
        "By a young, defiant god attempting to create something unheard of",
        "By an ancient civilization searching for the question to the answer of life, the universe, and everything",
        "It was hatched from the egg of a world-bearing chicken",
        "It wasn't. It has always been, and will always be",
        "It is one of many created by an immortal governing council.",
        "As the result of a wish spell",
        "It only exists in a snow globe created by a child, who in turn lives in a snow globe created by a child, who in turn...",
        "It started in the realm of imagination and become wholly realized through a chance run-in with the astral plane.",
        "A council of dragons pieced it together from favored parts of their home worlds",
        "It was created as an experiment run-amok by a god",
        "World creation was a pass-time of bored gods, who frequently made worlds, trying to one-up each other",
        "Two worlds colliding together",
        "It was born in the belly of a god-dragon, where her god-children warred, and was later cut out of her belly when one of her children committed matricide",
        "A world-dragon was butchered and its parts were turned into the sky, water, land, etc.",   ]},
            
    ////////////////////////
    //  -={Helpers}=- {42-49}
    ////////////////////////

    {"title": "d10 Mineral", "id":"d10mineral", "roll":[
        "Gold", "Silver", "Copper", "Adamantine", "Titanium", "Tungsten", "Platinum", "Electrum", "Uranium", "Unobtanium"]},
    {"title": "d20 Mineral", "id":"d20mineral", "roll":[
        "Gold", "Silver", "Copper", "Adamantine", "Titanium", "Tungsten", "Platinum", "Electrum", "Uranium", "Lead", "Granite", "Iron", "Aluminum", "Tin", "Salt", "Sulfer", "Cobalt", "Nickle", "Zinc", "Mercury"]},
    {"title": "d6 Recent Cataclysm", "id":"d6recentcataclysm", "roll":[
        "A massive meteor recently changed the entire landscape", 
        "A massive volcano recently erupted, blacking out the sky", 
        "A recent drought caused massive dust storms, and food became scarce", 
        "Massive floods recently wiped out anyone that was not prepared", 
        "A god recently became angry and punished the people by scorching the land",
        "A pandemic recently spread like wildfire, killing 60 percent of the population"]},
    {"title": "d10 LandType", "id":"d10landtype", "roll":[
        "Mountains", "Desert", "Forests", "Jungle", "Tundra", "Plains", "Lakes", "Rivers", "Swamp / Marshland", "Canyons"]},
    {"title": "d8 Sun Color", "id":"d8suncolor", "roll":[
        "Red", "Blue", "Green", "White", "Black", "Violet", "Purple", "Prismatic"]},
    {"title": "d12 Species Take Over", "id":"d12speciestakeover", "roll":[
        "Dragons", "Mind-flayers", "Dark elves", "A vampire", "A lich", "A fiend", "A celestial", "A beholder", "Dinosaurs", "Dopplegangers", "Mimics", "Titans"]},
    {"title": "d20 Planes", "id":"d20planes", "roll":[
        "The Astral Plane", "The Ethereal Plane", "The Feywild", "Shadowfell", "The Elemental Plane of Air", "The Elemental Plane of Earth", "The Elemental Plane of Water",
        "The Elemental Plane of Fire", "Pandemonium", "The Abyss", "The Blessed Fields of Elysium", "The Wilderness of The Beastlands", "The Olympian Glades of Arborea",
        "The Heroic Domains of Ysgard", "The Ever-Changing Chaos of Limbo", "The Tarterian Depths of Carceri", "The Gray Waste of Hades", 
        "The Bleak Eternity of Gehenna", "The Nine Hells of Baator", "The Infinite Battlefield of Acheron"]},
    {"title": "d8 God Experiment", "id":"d8godexperiment", "roll":[
        "The soul", "True sentience and free-will", "A purpose for their eternity", "A new form of magic", "A superior species that would some day replace them", 
        "A superior species that would some day serve them", "A superior species that would be pit against another council's species in a game of war", "A new non-naturally occurring material, such as plastic"]},

]